import { APP_NAME, APP_TAGLINE } from '../config'

export function SignIn({ onSignIn, busy }: { onSignIn: () => void; busy: boolean }) {
  return (
    <main className="signin">
      <div className="signin__card">
        <span className="signin__mark" aria-hidden />
        <h1 className="signin__title">{APP_NAME}</h1>
        <p className="signin__tagline">{APP_TAGLINE}</p>
        <p className="signin__body">
          Sign in with your Brinkmann account to review contract language, surface risk, and get
          answers grounded in our contract standards.
        </p>
        <button type="button" className="btn btn--primary" onClick={onSignIn} disabled={busy}>
          {busy ? 'Signing in…' : 'Sign in with Microsoft'}
        </button>
      </div>
    </main>
  )
}
